import React from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    SurgeryTitle,
    SurgerySubTitle,
    DetailsMainContainerBlock,
    MainContainerItems,
} from './SurgeryDetails.styled';

import { getDisplayDate, getTimeZoneName } from 'src/utils/dateUtils.js';

import {
    convertDurationToText,
    convertTime24To12,
    territoryValue,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { ENABLED, VISIBLE } from 'src/constants/appConstants';
import { sizes } from 'src/styles/Media.styled';
import { accountNumberZeroTrimmer } from 'src/utils/util';

const SurgeryDetails = ({ toggleCard, isSurgeryDetails }) => {
    const { t } = useTranslation();
    const surgeryDetails = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
    );
    const derivedTerritoryDetails = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                ?.derivedTerritoryDetails
    );
    const isConsignmentAdd = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.currentOrderType ===
            'KB'
    );
    const isUsage = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.currentOrderType ===
            'ZLB'
    );
    const implantDate = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.procedureDetail
                ?.implantDate
    );
    const surgeryDate = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails?.surgeryDate
    );
    const {
        physicianDropdownSurgeryVisibility,
        physicianDropdownZGSurgeryVisibility,
        physicianTextSurgeryVisibility,
        physicianTextConsignmentAddVisibility,
        physicianDropdownZGConsignmentAddVisibility,
    } = useSelector((state) => state.loginReducer);
    const { surgeryDeliveryDateVisibilityRule } = useSelector((state) => ({
        surgeryDeliveryDateVisibilityRule:
            state.loginReducer.surgeryDeliveryDateVisibilityRule,
    }));

    const orderBasicDetails = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails
    );
    const isFromOrderHistory = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.isFromOrderHistory
    );
    const specialStockPartner = useSelector(
        (state) => state.orderSummaryReducer.specialStockPartner
    );

    const isCondensedView = useSelector(
            (state) => state.loginReducer.isCondensedView
        );

    const {
        accountCode,
        accountName,
        contact,
        dateTime,
        requestedDeliveryDate,
        districtCode,
        districtName,
        duration,
        physicianName,
        territoryCode,
        territoryName,
        surgeryNumber,
    } = surgeryDetails || {};

    return (
        <>
            <CollapsableCard
                id="orders-surgeryDetails-surgeryDetails-details"
                title={
                    isConsignmentAdd
                        ? t(
                              'orders.orderQuickFilters.surgeryOrders.consignment'
                          )
                        : t('common.surgeryDetails')
                }
                onClick={() =>
                    toggleCard('isSurgeryDetails', !isSurgeryDetails)
                }
                isExpanded={isSurgeryDetails}
                padding={'0.8rem'}
                cursor={'pointer'}
                mobileMargin={isCondensedView ? '10px 16px 2px 16px': ''}
            >
                {isSurgeryDetails && surgeryDetails ? (
                    <DetailsMainContainerBlock>
                        {!isFromOrderHistory && (districtName || districtCode) ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderListViewFilterDropDown.district'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle className="order-surgery-contact-dt-mask">
                                    {districtName ? districtName : null}{' '}
                                    {districtCode ? districtCode : null}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {isFromOrderHistory ? null : derivedTerritoryDetails ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderListViewFilterDropDown.territory'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle className="order-surgery-contact-dt-mask">
                                    {territoryValue(derivedTerritoryDetails)}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : territoryName || territoryCode ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderListViewFilterDropDown.territory'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle className="order-surgery-contact-dt-mask">
                                    {territoryName} {territoryCode}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}

                        {accountName || accountCode ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderListViewFilterDropDown.account'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle className="order-surgery-contact-dt-mask">
                                    {accountName ? accountName : null}{' '}
                                    {accountCode ? accountNumberZeroTrimmer(accountCode) : null}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {!(accountName || accountCode) &&
                        orderBasicDetails.accountName ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'orders.orderListViewFilterDropDown.account'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle className="order-surgery-contact-dt-mask">
                                    {orderBasicDetails.accountName}{' '}
                                    {orderBasicDetails.accountNumber
                                        ? accountNumberZeroTrimmer(
                                              orderBasicDetails.accountNumber
                                          )
                                        : null}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {orderBasicDetails?.currentOrderType == 'KB' && specialStockPartner ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('ConsignmentAdd.stockPartner.title')}
                                </SurgeryTitle>
                                <SurgerySubTitle>
                                    {specialStockPartner}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {!isFromOrderHistory && orderBasicDetails.billToName ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('ConsignmentAdd.billToDetails.title')}
                                </SurgeryTitle>
                                <SurgerySubTitle className="orders-account-dt-mask">
                                    {orderBasicDetails.billToName}{' '}
                                    {accountNumberZeroTrimmer(
                                        orderBasicDetails.billToNumber
                                    )}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {physicianName && ((!isConsignmentAdd &&
                            (physicianDropdownSurgeryVisibility === VISIBLE ||
                                physicianDropdownZGSurgeryVisibility === VISIBLE ||
                                physicianTextSurgeryVisibility === VISIBLE)) ||
                        (isConsignmentAdd &&
                            physicianTextConsignmentAddVisibility ===
                                VISIBLE) ||
                        physicianDropdownZGConsignmentAddVisibility ===
                            'VISIBLE') ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'scheduleSurgery.details.AccountPhysicianTemplate.Physician'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle className="orders-physician-dt-mask">
                                    {physicianName ? physicianName : '\u00A0'}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {dateTime || duration ? (
                            <MainContainerItems
                                setMarginBottom={true}
                                // setMarginLeft={true}
                                // isSurgeryNumberWithDate={
                                //     isConsignmentAdd &&
                                //     surgeryDeliveryDateVisibilityRule ===
                                //         'VISIBLE'
                                //         ? false
                                //         : surgeryDeliveryDateVisibilityRule ===
                                //           'VISIBLE'
                                //         ? true
                                //         : false
                            >
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'scheduleSurgery.surgery.SurgeryReviewAndSuccess.dateAndTime'
                                    )}
                                </SurgeryTitle>

                                {!isUsage ? (
                                    <SurgerySubTitle>
                                        {getDisplayDate(new Date(dateTime))}{' '}
                                        {convertTime24To12(new Date(dateTime))}{' '}
                                        {`(${getTimeZoneName()})`}
                                        &nbsp;
                                        {duration ? ' | ' : ''}
                                        &nbsp;&nbsp;
                                        {/* Don't remove this &nbsp -> for space problem */}
                                        {duration ? convertDurationToText(duration) : ''}{' '}
                                    </SurgerySubTitle>
                                ) : surgeryDate ? (
                                    <SurgerySubTitle>
                                        {getDisplayDate(new Date(surgeryDate))}{' '}
                                        {convertTime24To12(
                                            new Date(surgeryDate)
                                        )}{' '}
                                        {`(${getTimeZoneName()})`}
                                    </SurgerySubTitle>
                                ) : (
                                    <SurgerySubTitle>
                                        {getDisplayDate(new Date(implantDate))}{' '}
                                        {convertTime24To12(
                                            new Date(implantDate)
                                        )}{' '}
                                        {`(${getTimeZoneName()})`}
                                    </SurgerySubTitle>
                                )}
                            </MainContainerItems>
                        ) : null}

                        {surgeryNumber ? (
                            <MainContainerItems
                                setMarginBottom={true}
                                // isSurgeryNumber={
                                //     isConsignmentAdd &&
                                //     surgeryDeliveryDateVisibilityRule ===
                                //         'VISIBLE'
                                //         ? false
                                //         : surgeryDeliveryDateVisibilityRule ===
                                //           'VISIBLE'
                                //         ? true
                                //         : false
                                // }
                            >
                                <SurgeryTitle showAstrisk={false}>
                                    {t('common.surgeryNumberLabel')}
                                </SurgeryTitle>
                                <SurgerySubTitle
                                // marginLeft={
                                //     window.innerWidth >= sizes.mobileDevice
                                //         ? '50px'
                                //         : ''
                                // }
                                >
                                    {' '}
                                    {surgeryNumber}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {surgeryDeliveryDateVisibilityRule === 'VISIBLE' &&
                        requestedDeliveryDate ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'scheduleSurgery.surgery.SurgeryReviewAndSuccess.requestedDeliveryDate'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle>
                                    {getDisplayDate(requestedDeliveryDate)}{' '}
                                    {/* {convertTime24To12(new Date(dateTime))}{' '} */}
                                    {/* {`(${getTimeZoneName()})`} {' | '} */}
                                    {/* &nbsp;&nbsp; */}
                                    {/* Don't remove this &nbsp -> for space problem */}
                                    {/* {convertDurationToText(duration)} */}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}

                        {!isFromOrderHistory && contact ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t(
                                        'scheduleSurgery.surgery.SurgeryReviewAndSuccess.contact'
                                    )}
                                </SurgeryTitle>
                                <SurgerySubTitle className="order-surgery-contact-dt-mask">{contact}</SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                    </DetailsMainContainerBlock>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default SurgeryDetails;
